<template>
  <el-form :model="DialogFormData">
    <!-- autoSize -->
    <el-input
      :class="{ grey: mode == 'forum' && !target_4_edit }"
      type="textarea"
      :rows="3"
      :placeholder="
        mode == 'forum'
          ? l('有什么新鲜事想分享给大家')
          : mode == 'comment'
          ? l('发布你的评论')
          : l('发布你的回复')
      "
      :maxlength="mode == 'forum' ? '500' : '200'"
      :show-word-limit="true"
      :clearable="true"
      resize="none"
      :autosize="{ minRows: 3 }"
      v-model="DialogFormData.content"
    >
    </el-input>
    <div class="operationPanel">
      <ResourceListUpLoad
        v-if="mode == 'forum'"
        key="img_array"
        ref="img_arrayUpload"
        prop="img_array"
        usage="forum"
        :initResourceUrl.sync="DialogFormData.img_array"
        :limit="9"
        size="small"
      />
      <el-checkbox
        v-else
        key="is_private"
        style="align-self: center"
        v-model="DialogFormData.is_private"
        >{{l('仅对方可见')}}</el-checkbox
      >

      <div class="btnList">
        <el-select
          v-if="mode == 'forum' && $store.state.basicInfo.tagList.forum.length"
          key="tag_id"
          v-model="DialogFormData.tag_id"
          :placeholder="l('请选择')"
          size="mini"
        >
          <el-option
            v-for="tag of $store.state.basicInfo.tagList.forum"
            :key="tag.id"
            :label="l(tag.name)"
            :value="tag.id"
          >
          </el-option>
        </el-select>
        <el-checkbox
          v-if="mode == 'forum'"
          style="color: #999; margin-left: 18px; margin-right: 20px"
          v-model="DialogFormData.is_private"
          >{{l('匿名')}}</el-checkbox
        >
        <el-button
          type="warning"
          size="mini"
          round
          style="width: 60px"
          :disabled="!DialogFormData.content"
          @click="submit"
        >
          {{ mode == "forum" ? l("发布") : mode == "comment" ? l("评论") : l("回复") }}
        </el-button>
      </div>
    </div>
  </el-form>
</template>

<script>
export default {
  name: "ForumPublish",
  props: {
    mode: {
      type: String,
      default: "forum", //forum comment reply
    },
    target: {
      //回复目标
      type: Object,
      default: () => ({}),
    },
    target_4_edit: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      DialogFormData: {
        id: null,
        tag_id: null,
        content: "",
        img_array: [],

        is_private: false,
      },
    };
  },
  created() {
    //编辑
    if (this.target_4_edit) {
      this.DialogFormData = this.target_4_edit;
    }
    //新增
    else {
      if (this.mode == "forum") {
        //默认取第一个
        if (this.$store.state.basicInfo.tagList.forum.length) {
          this.DialogFormData.tag_id =
            this.$store.state.basicInfo.tagList.forum[0].id;
        }
        //如果已经在话题分类页则选中该话题分类
        if (this.$route.query.tag_id) {
          this.DialogFormData.tag_id = Number(this.$route.query.tag_id);
        }
      }
    }
  },
  watch: {
    //默认取第一个
    "$store.state.basicInfo.tagList.forum"(newVal) {
      if (newVal.length) {
        this.DialogFormData.tag_id = newVal[0].id;
      }
    },
  },
  methods: {
    submit() {
      if (!this.DialogFormData.content)
        return this.$message.error(this.l("请输入内容"));
      if (this.target_4_edit) {
        this.axios
          .put(`/api/forum/my_post/${this.target_4_edit.id}/`, {
            ...this.DialogFormData,
            img_array: JSON.stringify(this.DialogFormData.img_array),
          })
          .then(() => {
            this.$emit("submitDialog");
          });
      } else {
        let requestUrl = "";
        if (this.mode == "forum") {
          requestUrl = `/api/forum/my_post/`;
        } else if (this.mode == "comment") {
          requestUrl = `/api/forum/my_post/comment/`;
        } else if (this.mode == "reply") {
          requestUrl = `/api/forum/my_post/reply/`;
        }
        this.axios
          .post(requestUrl, {
            ...this.DialogFormData,
            img_array: JSON.stringify(this.DialogFormData.img_array),

            forum_id: this.target.id,
            reply_id: this.target.id,
          })
          .then(() => {
            this.DialogFormData.content = "";
            this.DialogFormData.img_array = [];
            this.DialogFormData.forum_id = null;
            this.DialogFormData.reply_id = null;
            this.DialogFormData.is_private = false;
            this.$refs.img_arrayUpload &&
              this.$refs.img_arrayUpload.clearFiles();
            this.$emit("submitDialog");
          });
      }
    },
  },
};
</script>


<style scoped lang="scss">
.grey {
  /deep/textarea {
    background: #f0f1f4;
    border: 1px solid #f0f1f4;
    padding: 10px 15px;
    border-radius: 8px;

    &:focus {
      border-color: $warningColor;
      background: #fff;
    }
  }
  /deep/.el-input__count {
    background: transparent;
  }
}
.operationPanel {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  box-sizing: border-box;
  padding-bottom: 12px;
  .btnList {
    flex-shrink: 0;
    .el-select {
      width: 120px;
    }
    /deep/.el-input__inner {
      border: none;
      font-size: 14px;
      color: #999;
      text-align: right;
    }
  }
}
</style>

